import React from "react";
import { Box, Typography, Card, CardMedia, CardContent } from "@mui/material";
import { LOW_IN_STOCK_CONSTANTS } from "../../constants/lang";
import StyledLowInStock from "./StyledLowInStock";
import NoDataFound from "./NoDataFound";
import ShimmerLoader from "../../components/CommonComponents/Loader/ShimmerLoader";
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import wanderobelogo from "../../assets/images/wanderobe-logo-1.svg";

const LowInStockCards = ({ products, loading }) => {

  return (
    <StyledLowInStock>
      <Box className="main-container">
        <Typography className="main-title">
          {LOW_IN_STOCK_CONSTANTS.sectionTitle}
        </Typography>
        {loading ? <div className="loader-container">
          <ShimmerLoader />
        </div>
          : products?.length > 0 ?
            <Box className="cards-container">
              {products.map((product, index) => (
                <Card key={index} className="cards-box">
                  <CardMedia
                    className="cards-img"
                    component="img"
                    sx={{ objectFit: product?.image ? "cover" : "contain" }}
                    image={ product?.image || wanderobelogo}
                    alt={product.title}
                  />

                  <CardContent
                    className="content-box-1"

                  >
                    <Typography className="title">
                      {LOW_IN_STOCK_CONSTANTS.lowInStockLabel}
                    </Typography>
                    <Typography className="detail">{product.stock_left} left in stock</Typography>
                    <Typography className="product">{product.name}</Typography>
                    <Typography className="value">${product.price}</Typography>
                  </CardContent>
                </Card>
              ))}
            </Box>
            : <NoDataFound icon={<ShoppingBagOutlinedIcon className="icon-no-data" />} heading="No Items Running Low" subHeading="Your collection is fully stocked and ready to shine." />}

      </Box>
    </StyledLowInStock>
  );
};

export default LowInStockCards;
